<template>
  <v-app
    id="planbordtweb"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
    <router-view />
    <global-loader />
    <snack-bars />
  </v-app>
</template>

<script>
import GlobalLoader from "./components/commonComponents/GlobalLoader.vue";
import SnackBars from "./components/commonComponents/SnackBars.vue";
import { mapActions } from "vuex";
export default {
  name: "App",
  components: {
    GlobalLoader,
    SnackBars,
  },
  mounted() {
    this.setCurrentEnvironment();
    this.fetchServerEnvironment();
    this.fetchThemeRegular();
    this.$auth.fetch();
  },
  methods: {
    ...mapActions("tools", ["setCurrentEnvironment", "fetchServerEnvironment"]),
    ...mapActions("theme", ["fetchThemeRegular"]),
  },
};
</script>
